<template>
  <div class="flex flex-col">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <div
          class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
        >
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th
                  v-for="(item, index) in columns"
                  :key="index"
                  scope="col"
                  class="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider"
                >
                  {{ item.label }}
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200 animate-pulse">
              <tr v-for="row in rows" :key="row" class="text-sm font-medium">
                <td
                  v-for="(col, cIndex) in columns"
                  :key="cIndex"
                  class="px-6 py-3 whitespace-nowrap"
                >
                  <div class="h-4 bg-gray-200 rounded-full"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <span class="sr-only">Loading...</span>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Number,
      default: 8,
    },
  },
};
</script>

<style scoped></style>
